import { Layout, theme, Typography } from "antd";

import MeetingDetails from "../components/meetings/MeetingDetails";
import { useSearchParams } from "react-router-dom";

const { Content } = Layout;
const MeetingOverview = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const [searchparams] = useSearchParams();
  const meetingName = searchparams.get("meetingName");

  return (
    <Layout
      style={{
        marginLeft: 200,
      }}
    >
      <Content
        style={{
          margin: "24px 16px 0",
          overflow: "initial",
        }}
      >
        <Typography.Title level={4} className="titles-start">
          {meetingName}
        </Typography.Title>
        <div
          className="page-container"
          style={{
            background: colorBgContainer,
          }}
        >
          <MeetingDetails />
        </div>
      </Content>
    </Layout>
  );
};

export default MeetingOverview;
